import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Grid } from '../../../core/components/grid/grid.model';

@Component({
    selector: 'tt-production-routing-add',
    templateUrl: './production-routing-add.component.html',
    styleUrls: ['./production-routing-add.component.css'],
    standalone: false
})
export class ProductionRoutingAddComponent implements OnInit {
    prodId;

    public setting?: Setting;

    public selectListProductionRoutings: ProductionRoutingItem[] = [];

    public grid?: GridOptions;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodId = this.stateService.getStateParams()['prod_id'];
    }

    private async loadSetting() {
        if (!!this.prodId) {
            this.setting = (await this.datatask.Post(3656, { prod_id: this.prodId }))[0];
        }
    }

    private async loadProductionRoutings() {
        this.selectListProductionRoutings = await this.datatask.Post(3658);
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_productionroutingadd_grid')
                .setLoadDataFunction({
                    method: 3657,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'productionrouting_keyno':
                this.loadGrid();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadProductionRoutings();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    prod_id: string;
    productionrouting_keyno: string;
    use_productionrouting_is_possible: string;
    warning_message: string;
}

interface ProductionRoutingItem {
    productionrouting_keyno: string;
    productionroutinglang_name: string;
}
